import React from "react";
import TestCard from "./TestCard";
import { Checkbox } from "@mui/material";

export const TestCardWithCheckBox = (
  test,
  planData,
  index,
  expandedIndex,
  setExpandedIndex,
  updateTestStatusHandler,
  updateAttachTestHandler
) => {
  return (
    <div>
      <div>
        <Checkbox />
      <TestCard
        planData={planData}
        testData={test}
        key={test?.id}
        index={index}
        expandedIndex={expandedIndex}
        setExpandedIndex={setExpandedIndex}
        updateTestStatusHandler={updateTestStatusHandler}
        updateAttachTestHandler={updateAttachTestHandler}
      />

    </div>
    </div>
  );
};
